export const POS_SUPPORTED_PRINTERS = [
  { name_prefix: 'TSP143', vendor: 'Star', model: 'TSP143IV-BI' },
] as const;

export type PrinterSpec = (typeof POS_SUPPORTED_PRINTERS)[number];
